import { Button, Flex, forwardRef, Text, Tooltip } from '@chakra-ui/react';
import { rem } from 'polished';

import { ChevronRightIcon, InfoIcon } from '@sphere/icons';

import { MotionBox } from '../MotionBox/MotionBox';

export type AccordionButtonProps = {
  label?: string;
  tooltipContent?: string;
  isOpen?: boolean;
  isDisabled?: boolean;
  onClick?: () => void;
  testId?: string;
};

const variants = {
  active: {
    rotate: -90,
  },
  inactive: {
    rotate: 90,
  },
};

export const AccordionButton = forwardRef<AccordionButtonProps, 'button'>(
  ({ label, tooltipContent, isOpen, isDisabled, onClick, testId = 'accordion-button' }, ref) => (
    <Button
      ref={ref}
      data-testid={testId}
      width="100%"
      border="1px solid"
      borderColor={isOpen ? 'gray.2' : 'border'}
      background={isOpen ? 'gray.4' : 'gray.2'}
      color="white"
      variant="clear"
      px="space.16"
      isDisabled={isDisabled}
      height={rem(56)}
      borderRadius="radius.8"
      onClick={onClick}
      justifyContent="start"
      _hover={{ borderColor: isOpen ? 'transparent' : !isDisabled ? 'gray.5' : 'inherit' }}
    >
      <Flex justifyContent="space-between" alignItems="center" width="100%">
        <Flex alignItems="center">
          <Text
            fontWeight="400"
            as="span"
            display="block"
            lineHeight="shorter"
            color={isOpen ? 'white' : 'gray.1'}
            fontSize="md"
          >
            {label}
          </Text>
          {tooltipContent && (
            <Tooltip label={tooltipContent} placement="top" hasArrow arrowSize={8}>
              <InfoIcon ml="space.8" boxSize={rem(14)} />
            </Tooltip>
          )}
        </Flex>
        <MotionBox
          ml="auto"
          variants={variants}
          animate={isOpen ? 'active' : 'inactive'}
          initial={isOpen ? 'active' : 'inactive'}
        >
          <ChevronRightIcon color={isOpen ? 'white' : 'gray.1'} boxSize={rem(12)} />
        </MotionBox>
      </Flex>
    </Button>
  ),
);
